<template>
  <div>
    <b-navbar
      class="main-menu"
      toggleable="lg"
      type="dark"
      variant="info"
      v-if="displayType === 1"
    >
      <b-navbar-brand href="#">
        <img
          style="width:132px;"
          src="../assets/logo-white.svg"
          alt="MPR-logo"
        />
      </b-navbar-brand>
      <span class="mpr-title">MPR</span>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="/">Dashboard</b-nav-item>
          <b-nav-item href="#" active>Upload</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item right href="#">
            <span class="white" v-if="userId !== null"
              >Signed in as {{ userId }}</span
            >
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="dashboard-menu" v-if="displayType === 2">
      <div class="button-left">
        <button class="menu-item" v-on:click="undoClicked">
          <span class="button-text"
            ><i class="fas fa-undo"></i>&nbsp; Undo</span
          >
        </button>
        <button class="menu-item" v-on:click="redoClicked">
          <span class="button-text"
            ><i class="fas fa-redo"></i>&nbsp; Redo</span
          >
        </button>
        <button class="menu-item" v-on:click="revertClicked">
          <span class="button-text"
            ><i class="fas fa-step-backward"></i>&nbsp; Revert to Default</span
          >
        </button>
      </div>
      <div class="button-right">
        <button class="menu-item" v-on:click="uploadClicked">
          <span class="button-text">
            <i class="fas fa-file-upload"></i>&nbsp; Upload
          </span>
        </button>
        <button class="menu-item" v-on:click="showExportPDFDialogClicked">
          <span class="button-text">
            <i class="fas fa-file-pdf"></i>&nbsp; Download PDF
          </span>
        </button>
        <button class="menu-item" v-on:click="shareClicked">
          <span class="button-text">
            <i class="fas fa-share-alt"></i>&nbsp; Share
          </span>
        </button>
        <button class="menu-item" v-on:click="downloadClicked">
          <span class="button-text">
            <i class="fas fa-cloud-download-alt"></i>&nbsp; Download Source File
          </span>
        </button>
        <button class="menu-item" v-on:click="fullScreenClicked">
          <span class="button-text">
            <i class="fas fa-expand"></i>&nbsp; Full Screen
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.main-menu {
  height: 50px;
  width: 100%;
  background-color: #0083be !important;
  padding: 0px;
}
.main-menu .white {
  color: white;
}
.navbar-brand {
  padding: 10px;
}
.nav-link {
  padding: 13px 30px !important;
}
.nav-link.active {
  border-bottom: 3px solid white;
  padding: 12px 30px !important;
}
.navbar-dark .navbar-nav .nav-link:focus,
.navbar-dark .navbar-nav .nav-link:hover {
  color: hsla(0, 0%, 100%, 1);
}

.mpr-title {
  font-size: 24px;
  font-weight: bold;
  font-style: italic;
  color: white;
}
/* Dashboard menu */
.dashboard-menu {
  display: flex;
  height: 26px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f5f5;
  font-size: 11px;
  color: #333;
  border-bottom: 1px solid #d4d4d4;
}

.dashboard-menu .menu-item {
  color: #636363;
  font-size: 12px;
  font-family: Helvetica, sans-serif;
  background-color: #f5f5f5;
  border-style: none;
  border-width: 0;
  height: 100%;
  padding: 0px 12px;
  text-decoration: none;
  outline: none;
}

.dashboard-menu .menu-item:hover {
  cursor: pointer;
  background-color: #e6e6e6;
  height: 100%;
  color: #333;
}

.dashboard-menu .button-left {
  margin-right: auto;
  height: 100%;
}
.dashboard-menu .button-right {
  margin-left: auto;
  height: 100%;
}

.dashboard-menu .button-text {
  padding-left: 5px;
  font-size: 12px;
}
</style>
<script>
import AmplifyStore from "../store";
import EventBus from "../store/eventbus";

export default {
  name: "Menu",
  data() {
    return {};
  },
  computed: {
    displayType() {
      if (this.$route.name == "dashboard") {
        return 2;
      } else if (this.$route.name == "images") {
        return 0;
      } else {
        return 1;
      }
    },
    userId: function() {
      var userId = AmplifyStore.state.userId;
      return userId === null ? null : userId;
    },
  },
  methods: {
    undoClicked: function() {
      EventBus.$emit("mpr-undo");
    },
    redoClicked: function() {
      EventBus.$emit("mpr-redo");
    },
    revertClicked: function() {
      EventBus.$emit("mpr-revert");
    },
    showExportPDFDialogClicked: function() {
      EventBus.$emit("mpr-showExportPDFDialog");
    },
    uploadClicked: function() {
      this.$router.push({ name: "upload" });
    },
    shareClicked: function() {
      EventBus.$emit("mpr-share-link");
    },
    downloadClicked: function() {
      EventBus.$emit("mpr-download-file");
    },
    fullScreenClicked: function() {
      var elem = document.getElementById("app");
      // var iframeElem = document.querySelector("#tableau > iframe");
      var requestMethod =
        elem.requestFullscreen ||
        elem.webkitRequestFullScreen ||
        elem.mozRequestFullScreen ||
        elem.msRequestFullscreen;
      if (requestMethod) {
        requestMethod.call(elem);
      }
    },
  },
};
</script>
